import * as S from "./styles";

interface Props {
  leftClick: React.MouseEventHandler<HTMLButtonElement>;
  response: boolean;
  rightClick: React.MouseEventHandler<HTMLButtonElement>;
  onClick?: (isTrue: boolean) => void;
  label: string;
}

export function ToggleButton({
  label,
  leftClick,
  rightClick,
  onClick = () => {},
  response,
}: Props) {
  return (
    <S.ToogleContainer>
      <label>{label}</label>
      <S.ToggleButton>
        <S.Button
          onClick={(e) => {
            leftClick(e);
            onClick(true);
          }}
          type="button"
          variant={!response ? "leftActive" : "leftButton"}
        >
          Sim
        </S.Button>
        <S.Button
          onClick={(e) => {
            rightClick(e);
            onClick(false);
          }}
          type="button"
          variant={response ? "rightActive" : "rightButton"}
        >
          Não
        </S.Button>
      </S.ToggleButton>
    </S.ToogleContainer>
  );
}
